





















import OrgService from '@/api/org.service';
import { SET_ORG_DETAILS, STORE_REACTIVATION_SETTINGS } from '@/store/mutation-types';
import { IReactivation, IUser } from '@/store/types';
import Vue from 'vue';

export default Vue.extend({
  name: 'ReactivationBcc',
  data() {
    return {
      team: [] as IUser[],
      loading: false,
    };
  },
  async created() {
    this.fetchMembers();
    this.loading = false;
  },
  computed: {
    reactivation(): IReactivation {
      return this.$store.state.org?.reactivation || {};
    },
    bcc(): string[] {
      return this.reactivation?.bcc || [];
    },
  },
  methods: {
    async save() {
      await OrgService.updateReactivationSettings(this.$store.state.org._id, { bcc: this.bcc });
    },
    update(bcc: string[]) {
      this.$store.commit(STORE_REACTIVATION_SETTINGS, { bcc });
      this.save();
    },
    async fetchMembers() {
      try {
        this.team = await OrgService.getMembers(this.$store.state.user.org);
      } catch (error) {
        console.log(error);
      }
    },
  },
});
